module.exports = "/_next/static/images/DevfestAurangabad2-9ac05aa801b37b4d5b5f091c64751806.jpg";